import {
  Button,
  Card,
  Grid,
  Icon,
  InputItem,
  List,
  Modal,
  NavBar,
  SearchBar,
  Tabs,
  Toast,
  WhiteSpace,
  WingBlank,
} from "antd-mobile";
import Input from "antd-mobile/lib/input-item/Input";

//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../util/axios";
const HomePage = styled.div`
  .body {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    margin: 0;
    padding: 0;
    position: absolute;
    left: 0;
    top: 0;
  }
  .button {
    position: absolute;
    top: 60%;
    width: auto;
    margin-left: 27px;
    margin-right: 27px;
    height: 48px;
    background-color: #e7191d;
    border-radius: 6px;
    color: white;
  }
  img {
    position: absolute;
    width: 50%;
    top: 20%;
    left: 27px;
  }
  .List {
    position: absolute;
    top: 35%;
    padding: 0 20px 0 20px;
  }
`;
export default function LoginList() {
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const history = useHistory();
  return (
    <>
      <HomePage style={{ height: "100%" }}>
        <div className="body">
          <img src="/login.png" alt="" />
          <List className="List">
            <InputItem type="text" placeholder="请输入用户名">
              用户名
            </InputItem>
            <InputItem type="password" placeholder="请输入密码">
              密码
            </InputItem>
          </List>

          <Button
            type="primary"
            className="button"
            onClick={() => {
              history.push(`/hr/index`);
            }}
          >
            登陆
          </Button>
        </div>
      </HomePage>
    </>
  );
}
